<template>
  <div class="lt">

    <div class="lt-bottom">
      <div class="lt-bt-item" v-for="(item, index) in dataMap" :key="index">
        <img :src="item.imgUrl" alt="imgUrl" class="bt-bg-img" />
        <div class="lt-item-content">
          <div class="item-num">{{ item.num1 }}</div>
          <div class="lt-item-title">{{ item.name }}</div>
        </div>


      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'template4.leftTop4',
  data() {
    return {
      //线路列表
      topMap: [],
      select: {},
      // 已选高速详情列表 name描述 val蓝色字体 unit白色字体
      dataMap: [
        { name: "客户数", imgUrl: require('../../assets/template4/lt1.png'), num1: '364', },
        { name: "新增付费客户数", imgUrl: require('../../assets/template4/lt2.png'), num1: '364', },
        { name: "新增续费客户数", imgUrl: require('../../assets/template4/lt3.png'), num1: '364', },
        { name: "同比续费客户数", imgUrl: require('../../assets/template4/lt4.png'), num1: '364', },


      ],
    };
  },
  watch: {},
  methods: {
    change(item) {
      // if (item.id == this.select.id) return;
      // this.select = item;
      // this.$emit('roadselect', item)
    },
    setloadreal() {
      // const dalong = this.topMap.find((item) => item.id == 1005);
      // this.change(dalong);
    },

  },
  mounted() {
    // getHighway().then(res => {
    // 	this.topMap = res.data
    // 	this.change(this.topMap[0])
    // })
  },
};
</script>

<style scoped lang="scss">
@font-face {
  font-family: "Benmo-Ziyu";
  src: url("../../assets/fonts/Benmo-Ziyu.woff2");
}

.lt {
  width: 435px;
  height: 240px;
  display: flex;
  padding: 10px 0;
  position: relative;
}

.lt-bottom {
  margin-top: 20px;
  height: 200px;
  width: 435px;
  display: flex;
  flex-wrap: wrap;
}

.lt-bt-item {
  width: 217px;
  height: 80px;
  position: relative;
}

.lt-bt-item:nth-child(2n) {
  margin-left: -20px;
}

.bt-bg-img {
  width: 51px;
  height: 58px;
  position: absolute;
  left: 16px;
  top: 20px;

}

.lt-item-content {
  // display: flex;
  position: absolute;
  top: 20px;
  left:82px;
}

.lt-item-title {
  font-family: Source Han Sans CN;
  font-weight: 500;
  font-size: 18px;
  color: #D6EEF6;

}

.item-num {
  font-family: Source Han Sans CN;
  font-weight: 500;
  font-size: 20px;
  color: #F5C070;

}
</style>